const doAndWait = async (func: () => void, delay: number): Promise<void> => {
  func();
  return new Promise(res => setTimeout(() => res(), delay));
};

export default doAndWait;
